import moment from 'moment';
import { ResourceType } from 'api/resource-management/types';
import { defaultFormat } from 'utils/date-field/formatter';
import { weekendHighlightAsUIFormatForTemplate } from './weekend-highlight-for-template';
import { AllWorkingDayConfig, getDateAfterSomeNumberOfWorkingDays } from './working-days';
export const asTemplateAllocation = (relativeDate, isHoursPerWeek)=>(allocation)=>{
        var _allocation_billable;
        let adjStartDate = allocation.startDate;
        let adjEndDate = allocation.endDate;
        if (isHoursPerWeek) {
            const allocationStartDate = moment(allocation.startDate);
            const startDate = allocationStartDate.diff(relativeDate, 'days');
            const allocationEndDate = moment(allocation.endDate);
            const adjDuration = allocationEndDate.diff(allocationStartDate, 'days') + 1;
            const adjustedStartDate = getDateAfterSomeNumberOfWorkingDays(relativeDate, startDate, AllWorkingDayConfig);
            const adjustedEndDate = getDateAfterSomeNumberOfWorkingDays(adjustedStartDate, adjDuration - 1, AllWorkingDayConfig);
            adjStartDate = defaultFormat(adjustedStartDate);
            adjEndDate = defaultFormat(adjustedEndDate);
        }
        const startDay = moment(adjStartDate).diff(relativeDate, 'day');
        const duration = moment(adjEndDate).diff(moment(adjStartDate), 'day') + 1;
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        let weekendHighlightForUI = [];
        if (isHoursPerWeek) {
            var _allocation_includeSaturday, _allocation_includeSunday;
            weekendHighlightForUI = weekendHighlightAsUIFormatForTemplate(relativeDate, startDay, duration, (_allocation_includeSaturday = allocation.includeSaturday) !== null && _allocation_includeSaturday !== void 0 ? _allocation_includeSaturday : false, (_allocation_includeSunday = allocation.includeSunday) !== null && _allocation_includeSunday !== void 0 ? _allocation_includeSunday : false);
        }
        return {
            id: allocation.id,
            minutes: allocation.minutes,
            projectPhaseId: allocation.projectPhaseId,
            billable: (_allocation_billable = allocation.billable) !== null && _allocation_billable !== void 0 ? _allocation_billable : true,
            startDay,
            duration,
            medium: allocation.medium,
            ...allocation.type === ResourceType.User ? {
                type: ResourceType.User,
                userId: allocation.userId
            } : {
                type: ResourceType.Team,
                teamId: allocation.teamId
            },
            sources: allocation.sources,
            includeSaturday: allocation.includeSaturday,
            includeSunday: allocation.includeSunday,
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            weekendHighlightForUI
        };
    };
